module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /dist/src/app/user/user.component.html
// module id = ../../../../../src/app/user/user.component.html
// module chunks = main